import { BatchFormFieldType } from 'components/batchForm/BatchForm.helpers';
import { createContext, DragEvent } from 'react';

export type BatchDragAndDropContextValue = {
  dragHandleCellId?: string;
  setDragHandleCellId?: (cellId: string | undefined) => void;
  originalDraggedValue?: BatchFormFieldType;
  setOriginalDraggedValue?: (value: BatchFormFieldType | undefined) => void;
  dragHoveredCellIds?: string[];
  setDragHoveredCellIds?: (cellIds?: string[]) => void;
  draggedCellIdsForCopy?: string[];
  setDraggedCellIdsForCopy?: (cellIds?: string[]) => void;
  onDragStart?: (e: DragEvent, rowIndex: number, columnIndex: number) => void;
  onDragOver?: (e: DragEvent, rowIndex: number, columnIndex: number) => void;
  onDrop?: (e: DragEvent, rowIndex: number) => void;
};

export const BatchDragAndDropContext = createContext<BatchDragAndDropContextValue>({});
